var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Radio from 'antd/lib/radio';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import Icon from './Icon';
import Gradient from './GradientEdit';
import RowHelp from './RowHelp';
import SelectInput from './SelectInput';
import { getBgImageUrl, getBgImageType, getRadioButton, getOption, getOptionArray, getParentNode, defaultBgImageOrGradient, } from '../../utils';
var RadioGroup = Radio.Group;
var RadioButton = Radio.Button;
var BackGroundPop = /** @class */ (function (_super) {
    __extends(BackGroundPop, _super);
    function BackGroundPop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (k, v, isDrag) {
            var _a = _this.props, value = _a.value, num = _a.num;
            Object.keys(value).forEach(function (key) {
                if (key === k) {
                    value[key][num] = v;
                }
                ;
            });
            _this.props.onChange(value, isDrag);
        };
        _this.getType = function () {
            var _a = _this.props, num = _a.num, value = _a.value;
            var url = value.image[num];
            return getBgImageType(url);
        };
        _this.getTypeToRender = function (type) {
            var _a = _this.props, locale = _a.locale, className = _a.className;
            return (React.createElement(Row, { gutter: 8, className: className + "-type" },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "bg-type", prompt: locale.type })),
                React.createElement(Col, { span: 21 },
                    React.createElement(RadioGroup, { value: type, size: "small", onChange: function (e) {
                            var v = e.target.value;
                            _this.onChange('image', defaultBgImageOrGradient[v]);
                        } }, ['img', 'linear', 'radial'].map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
                        React.createElement(Icon, { type: key === 'img' ? 'picture' : "bg-type-" + key, prompt: locale[key], destroyTooltipOnHide: true }))); })))));
        };
        _this.getCommon = function () {
            var _a = _this.props, locale = _a.locale, value = _a.value, num = _a.num;
            return [
                React.createElement(RowHelp, { title: React.createElement(Icon, { type: "filter", prompt: locale.blendMode }), help: locale.blendModeHelp, key: "filter" },
                    React.createElement(Select, { style: { width: '100%' }, value: value.blendMode[num], size: "small", onChange: function (e) {
                            _this.onChange('blendMode', e);
                        }, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOptionArray(_this.blendMode))),
                React.createElement(RowHelp, { title: React.createElement(Icon, { type: "clip", prompt: locale.clip }), help: locale.clipHelp, key: "clip" },
                    React.createElement(Select, { style: { width: '100%' }, value: value.clip[num], size: "small", onChange: function (e) {
                            _this.onChange('clip', e);
                        }, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOption(locale.clipSelect))),
                React.createElement(Row, { gutter: 8, key: "attachment" },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "attachment", prompt: locale.attachment })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(RadioGroup, { value: value.attachment[num], size: "small", onChange: function (e) {
                                var v = e.target.value;
                                _this.onChange('attachment', v);
                            } }, getRadioButton(_this.attachment))))
            ];
        };
        _this.getGradientChild = function (type) {
            var _a = _this.props, className = _a.className, props = __rest(_a, ["className"]);
            return (React.createElement("div", null,
                React.createElement(Gradient, __assign({}, props, { type: type })),
                _this.getCommon()));
        };
        _this.getImageChild = function () {
            var _a = _this.props, locale = _a.locale, value = _a.value, num = _a.num;
            return (React.createElement("div", null,
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "picture", prompt: locale.image })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(Input, { value: getBgImageUrl(value.image[num]), onChange: function (e) {
                                var v = e.target.value;
                                _this.onChange('image', "url(" + v + ")");
                            }, size: "small", placeholder: "Add image url" }))),
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "repeat", prompt: locale.repeat })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(Select, { style: { width: '100%' }, value: value.repeat[num], size: "small", onChange: function (e) {
                                _this.onChange('repeat', e);
                            }, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOption(locale.repeatSelect)))),
                React.createElement(RowHelp, { title: React.createElement(Icon, { type: "imagePosition", prompt: locale.position }), help: locale.position_help },
                    React.createElement(SelectInput, { style: { width: '100%' }, value: value.position[num] || '', size: "small", onChange: function (e) {
                            _this.onChange('position', e);
                        } }, getOptionArray(_this.position))),
                React.createElement(RowHelp, { title: React.createElement(Icon, { type: "size", prompt: locale.size }), help: locale.size_help },
                    React.createElement(SelectInput, { style: { width: '100%' }, value: value.size[num] || '', size: "small", onChange: function (e) {
                            _this.onChange('size', e);
                        } }, getOptionArray(_this.size))),
                _this.getCommon()));
        };
        _this.getChildToRender = function (type) {
            switch (type) {
                case 'img':
                    return _this.getImageChild();
                case 'linear':
                case 'radial':
                    return _this.getGradientChild(type);
                default:
                    return null;
            }
        };
        _this.position = ['center', 'center left', 'center right', 'top', 'top left',
            'top right', 'bottom', 'bottom left', 'bottom right'];
        _this.size = ['100%', '100% 50%', 'auto', 'contain', 'cover'];
        _this.attachment = ['scroll', 'local', 'fixed'];
        _this.blendMode = ['normal', 'multiply', 'screen', 'overlay', 'darken',
            'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light',
            'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'];
        _this.clip = ['border-box', 'padding-box', 'content-box'];
        return _this;
    }
    BackGroundPop.prototype.render = function () {
        var className = this.props.className;
        var type = this.getType();
        var typeToRender = this.getTypeToRender(type);
        var childToRender = this.getChildToRender(type);
        return (React.createElement("div", { className: className },
            typeToRender,
            childToRender));
    };
    BackGroundPop.propTypes = {
        className: PropTypes.string,
        locale: PropTypes.object,
        value: PropTypes.any,
        onChange: PropTypes.func,
        num: PropTypes.number,
        type: PropTypes.string,
    };
    BackGroundPop.defaultProps = {
        className: 'editor-bg-image-pop',
    };
    return BackGroundPop;
}(React.Component));
export default BackGroundPop;
